import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Paginated } from '../models/generic-resource-model';
import { NotificationHistory } from '../models/notification-history.model';
import { ResourceService } from './generic-http.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationHistoryService extends ResourceService<NotificationHistory>  {

    constructor(private http: HttpClient) {
        super(http, NotificationHistory, environment.apiUri + "/NotificationHistory");
    }

    public getAll<T>(): Observable<T[]> {
        let uri: string = '/all';
        return this.http
            .get<T[]>(this.apiUrl + uri);
    }

    public getPaginatedByUser<T>(userID: number, params?: HttpParams | any | {
      [param: string]: string | number | boolean | readonly (string | number | boolean)[];
    }) {
      if (userID == null || userID == undefined) return;
      return this.http.get<T[]>(`${this.apiUrl}/user/${userID}`, {
        observe: 'response',
        params
      }).pipe(map(response => {
        let paged: Paginated<T> = {
          pagination: JSON.parse(response.headers.get('x-pagination')),
          body: response.body as T[]
        }
        return paged;
      }));
  }

    public getLastestPaginated<T>(userID: number, params?: HttpParams | any | {
        [param: string]: string | number | boolean | readonly (string | number | boolean)[];
      }) {
        if (userID == null || userID == undefined) return;
        return this.http.get<T[]>(`${this.apiUrl}/lastest/${userID}`, {
          observe: 'response',
          params
        }).pipe(map(response => {
          let paged: Paginated<T> = {
            pagination: JSON.parse(response.headers.get('x-pagination')),
            body: response.body as T[]
          }
          return paged;
        }));
    }

    public markNotificationsAsRead<T>(userID: number): Observable<T[]> {
      let uri: string = `/markasread/user/${userID}`;
      return this.http
          .put<T[]>(this.apiUrl + uri, null);
    }

    public markSingleNotificationAsRead<T>(id: number): Observable<T[]> {
      let uri: string = `/markasread/${id}`;
      return this.http
          .put<T[]>(this.apiUrl + uri, null);
    }


    public GetNotificationByUser = (id: number): Observable<any> => this.http.get(environment.apiUri+"/NotificationHistory/"+id);
    
    public getTable = (id: number): Observable<any> => this.http.get(environment.apiUri+"/NotificationHistory/table/"+id);


}
